import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { AirsideLogo } from "@llmgateway/shared/product-logos";
export function Logo(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("size-7", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <AirsideLogo className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}